import type { ReactNode } from 'react'
import { Alert, Button, Empty, Spin } from '@crosscode/gravity-components'
import styles from './Page.module.css'

interface Props {
  title: string
  /** Muted count/meta next to title, e.g. "6 узлов" */
  count?: string | number
  subtitle?: string
  actions?: ReactNode
  toolbar?: ReactNode
  loading?: boolean
  error?: string | null
  empty?: boolean
  emptyText?: string
  emptyDescription?: string
  onRetry?: () => void
  narrow?: boolean
  children?: ReactNode
}

export function Page({
  title,
  count,
  subtitle,
  actions,
  toolbar,
  loading,
  error,
  empty,
  emptyText = 'Нет данных',
  emptyDescription,
  onRetry,
  narrow,
  children,
}: Props) {
  return (
    <div className={`${styles.page}${narrow ? ` ${styles.narrow}` : ''}`}>
      <header className={styles.header}>
        <div className={styles.titleBlock}>
          <div className={styles.titleRow}>
            <h1 className={styles.title}>{title}</h1>
            {count != null && count !== '' ? <span className={styles.count}>{count}</span> : null}
          </div>
          {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
        </div>
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </header>

      {toolbar ? <div className={styles.toolbar}>{toolbar}</div> : null}

      {error ? (
        <Alert
          type="error"
          showIcon
          message={error}
          action={
            onRetry ? (
              <Button size="small" onClick={onRetry}>
                Повторить
              </Button>
            ) : undefined
          }
          style={{ marginBottom: 16 }}
        />
      ) : null}

      {loading ? (
        <div className={styles.loading}>
          <Spin size="large" />
        </div>
      ) : empty ? (
        <Empty
          description={
            <div>
              <div className={styles.emptyTitle}>{emptyText}</div>
              {emptyDescription ? <div className={styles.emptyDesc}>{emptyDescription}</div> : null}
            </div>
          }
        />
      ) : (
        children
      )}
    </div>
  )
}
